import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  FaArrowLeft,
  FaArrowRight,
  FaClock,
  FaExternalLinkAlt,
  FaLightbulb,
  FaMapMarkerAlt,
  FaRoute,
  FaStar,
} from "react-icons/fa";
import NavBar from "./nav";
import Footer from "./footer";
import VisitorTips from "./VisitorTips";
import { findJourneyItem, journeyItems } from "./journeyData";
import "../css/journeyDescription.css";

const JourneyDescription = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { slug } = useParams();
  const item = location.state?.item || findJourneyItem(slug);

  if (!item) {
    return (
      <div className="journey-description-page">
        <NavBar />
        <main className="journey-detail-container">
          <button className="journey-detail-back" onClick={() => navigate(-1)} type="button">
            <FaArrowLeft />
            Back
          </button>
          <section className="journey-empty-state">
            <h1>Details not found</h1>
            <p>Please return to the journey pages and choose another experience.</p>
          </section>
        </main>
        <Footer />
      </div>
    );
  }

  const relatedItems = journeyItems
    .filter((related) => related.slug !== item.slug)
    .slice(0, 3);

  return (
    <div className="journey-description-page">
      <NavBar />

      <main className="journey-detail-container">
        <button className="journey-detail-back" onClick={() => navigate(-1)} type="button">
          <FaArrowLeft />
          Back
        </button>

        <article className="journey-detail-shell">
          <header className="journey-detail-hero">
            <div className="journey-detail-image">
              <img src={item.image} alt={item.name} />
              <span>{item.category}</span>
            </div>
            <div className="journey-detail-copy">
              <p className="journey-detail-eyebrow">
                <FaRoute />
                Kimberley route guide
              </p>
              <h1>{item.name}</h1>
              <p>{item.description}</p>
              <div className="journey-detail-meta">
                <span>
                  <FaMapMarkerAlt />
                  {item.location}
                </span>
                <span>
                  <FaClock />
                  Flexible visit
                </span>
              </div>

              {item.officialWebsite && (
                <a
                  className="journey-official-link"
                  href={item.officialWebsite}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Official Website <FaExternalLinkAlt />
                </a>
              )}
            </div>
          </header>

          <section className="journey-detail-grid">
            <div className="journey-detail-main">
              <section className="journey-detail-section">
                <h2>About This Experience</h2>
                {item.content.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
              </section>

              <section className="journey-detail-section">
                <h2>Highlights</h2>
                <div className="journey-highlight-grid">
                  {item.highlights.map((highlight) => (
                    <div key={highlight}>
                      <FaStar />
                      <p>{highlight}</p>
                    </div>
                  ))}
                </div>
              </section>
            </div>

            <aside className="journey-detail-side">
              <section className="journey-tip-card">
                <span>
                  <FaLightbulb />
                </span>
                <h2>Visitor Note</h2>
                <p>{item.visitorNotes}</p>
              </section>

              <section className="journey-best-card">
                <h2>Best For</h2>
                <div>
                  {item.bestFor.map((bestFor) => (
                    <span key={bestFor}>{bestFor}</span>
                  ))}
                </div>
              </section>

              <section className="journey-related-card">
                <h2>More Ideas</h2>
                {relatedItems.map((related) => (
                  <button
                    key={related.slug}
                    type="button"
                    onClick={() =>
                      navigate(`/journey/${related.slug}`, {
                        state: { item: related },
                      })
                    }
                  >
                    <FaArrowRight />
                    {related.name}
                  </button>
                ))}
              </section>
            </aside>
          </section>
        </article>
      </main>
      <section className="detail-extra-section">
        <VisitorTips title={item.name} category={item.category || "Journey"} />
      </section>

      <Footer />
    </div>
  );
};

export default JourneyDescription;
